var map = {
	"./Logo-Newspeak-PIcto.png": 37,
	"./Logo-Newspeak-PIcto.svg": 121,
	"./airbnbLogo.png": 35,
	"./alisteLogo.webp": 26,
	"./brassgrab.webp": 122,
	"./codeInLogo.webp": 123,
	"./contactMail.webp": 124,
	"./contactMailDark.svg": 125,
	"./developerActivity.svg": 126,
	"./facebookLogo.png": 33,
	"./googleAssistant.svg": 127,
	"./googleAssistantLogo.webp": 128,
	"./greetingNew.svg": 39,
	"./harvardLogo.png": 31,
	"./jsFramework.svg": 129,
	"./krinqlLogo.webp": 36,
	"./legalmind.jpg": 130,
	"./legalmindLogo.webp": 27,
	"./manOnTable.svg": 131,
	"./nextuLogo.webp": 132,
	"./programmer.svg": 133,
	"./pwa.webp": 134,
	"./pwaLogo.webp": 135,
	"./quoraLogo.png": 34,
	"./saayaHealthLogo.webp": 136,
	"./skill.svg": 43,
	"./snapcount.webp": 137,
	"./stanfordLogo.png": 32,
	"./talksCardBack.svg": 138,
	"./talksCardBackAlt.svg": 139,
	"./undraw_feeling_proud_qne1.svg": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;